import { connect } from 'react-redux';
import Account from '../../../components/account/Account';

import {
  withdrawRequest,
  depositRequest,
} from '@xanadu/ui-shared/modules/user/actions';

import {
  triggerUpdateRightSidebar,
} from '../../../modules/rightSidebar/actions';

import {
  toggleCustomerOnboardingPopup,
} from '../../../modules/customerOnboarding/actions';

import {
  displayModal,
} from '@xanadu/ui-shared/modules/modal/actions';

const mapDispatchToProps = {
  withdrawRequest,
  displayModal,
  depositRequest,
  toggleCustomerOnboardingPopup,
  updateRightSidebar: triggerUpdateRightSidebar,
};

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    widthSize: state.getIn(['application', 'widthSize']),
    edgeStatus: state.getIn(['application', 'edgeStatus']),
    balance: state.getIn(['user', 'balance']),
    balanceLoading: state.getIn(['user', 'balanceLoading']),
    betBuilderRestricted: state.getIn(['betBuilder', 'restricted']),
    casinoPromotions: state.getIn(['promotions', 'main', 'casinoPromotions']),
    bonuses: state.getIn(['promotions', 'manualBonus', 'data']),
    countryId: state.getIn(['user', 'countryId']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);
